// extracted by mini-css-extract-plugin
export default {"root":"dr_Ce7aPyqKxUPvNidzs","title":"w0bkty1axrHO6ArPjQ3W","nothing":"pgPzWITIjdmP4WReaURR"};